import { render, staticRenderFns } from "./EditOrderItemLocationToggle.vue?vue&type=template&id=f800cd42&scoped=true"
import script from "./EditOrderItemLocationToggle.vue?vue&type=script&lang=js"
export * from "./EditOrderItemLocationToggle.vue?vue&type=script&lang=js"
import style0 from "./EditOrderItemLocationToggle.vue?vue&type=style&index=0&id=f800cd42&prod&lang=scss&scoped=true"
import style1 from "./EditOrderItemLocationToggle.vue?vue&type=style&index=1&id=f800cd42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f800cd42",
  null
  
)

export default component.exports